export var TileViewType = {
    twoRow: 'two_row',
    threeRow: 'three_row',
    fourRow: 'four_row'
};
export var getTileViewType = function (post) {
    var _a, _b, _c;
    return !!((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'tileViewType'; })) === null || _c === void 0 ? void 0 : _c.value : TileViewType.twoRow;
};
//# sourceMappingURL=TyleViewType.js.mapexport var TileViewType = {
    twoRow: 'two_row',
    threeRow: 'three_row',
    fourRow: 'four_row'
};
export var getTileViewType = function (post) {
    var _a, _b, _c;
    return !!((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'tileViewType'; })) === null || _c === void 0 ? void 0 : _c.value : TileViewType.twoRow;
};
//# sourceMappingURL=TyleViewType.js.map